import { useToastStore, type ToastType } from '@/shared/stores/toast.store'

function normalizeMessage(message: unknown): string {
  if (typeof message === 'string') {
    return message
  }
  if (message == null) {
    return ''
  }
  return String(message)
}

export function useToast() {
  const store = useToastStore()

  function show(message: unknown, type: ToastType, duration?: number) {
    const text = normalizeMessage(message)
    if (!text) {
      return
    }
    return store.push(text, type, duration)
  }

  return {
    success: (message: unknown, duration?: number) => show(message, 'success', duration),
    error: (message: unknown, duration?: number) => show(message, 'error', duration),
    warning: (message: unknown, duration?: number) => show(message, 'warning', duration),
    info: (message: unknown, duration?: number) => show(message, 'info', duration),
    default: (message: unknown, duration?: number) => show(message, 'info', duration),
  }
}
